// Creates a modal for uploading new audio files and assigning them to auto groups

class AudioUploadModal extends HTMLElement{
  constructor() {
    super();
  }
  async connectedCallback() {
    this.innerHTML = 
    `<div class="modal fade bd-example-modal-sm" id="manageAudioModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Audio Upload</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="errors"></div>
                <div class="form-group" style="clear:both;">
                  <label>Description</label>
                  <input id="audio-upload-description" type="text" class="form-control" placeholder="Audio description">
                </div>
                <div class="form-group" style="clear:both;">
                  <label>Audio Type</label>
                  <select is="audio-type-select" id="audio-upload-type-id" class="form-control"></select>
                </div>
                <div class="form-group">
                  <label for=prompt>Audio File</label>
                  <div class="input-group">
                    <span class="input-group-btn">
                      <span class="btn btn-primary btn-file" style="line-height: 24px;">
                          Browse&hellip; <input type="file" id="audio-upload-file" name=prompt accept=".ogg,.wav" single/>
                      </span>
                    </span>
                    <input type="text" id="audio-upload-file-text" class="form-control" readonly>
                  </div>
                </div>
                <div class="form-group" id="audio-modal-select">

                </div>
                <div class="form-group" style="overflow:auto;">
                  <a id="audio-modal-save" type=submit value='Save' class='btn btn-primary pull-right detail-row-button'>Save</a><a id="audio-modal-cancel" class='btn btn-outline-secondary pull-right detail-row-button'>Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;

    if(this.group_id == null) {
      let data_binder = new DataBinder("/admin/groups.json", true);
      await data_binder.fetchData();
      let data = data_binder.data;  
      let options = data.map(group => `<option value="${group.id}">${group.name}</option>`).join("");
      let audioModalSelect = `<div class="row">
                              <div class="col-sm-12">
                                <h3>Accessible Groups</h3>
                              </div>  
                              </div>
                              <div class="row">
                                <div class="col-sm-4">
                                  <span>Available</span>
                                  <select name="from[]" class="js-multiselect form-control" size="8" multiple="multiple">
                                    ${options}
                                  </select>
                                </div>
                                <div class="col-sm-4">
                                  </br>
                                  </br>
                                  <button type="button" id="js_right_All_1" class="btn btn-block"><i class="glyphicon glyphicon-forward"></i></button>
                                  <button type="button" id="js_right_Selected_1" class="btn btn-block"><i class="glyphicon glyphicon-chevron-right"></i></button>
                                  <button type="button" id="js_left_Selected_1" class="btn btn-block"><i class="glyphicon glyphicon-chevron-left"></i></button>
                                  <button type="button" id="js_left_All_1" class="btn btn-block"><i class="glyphicon glyphicon-backward"></i></button>
                                </div>
                                <div class="col-sm-4">
                                  <span>Selected</span>
                                  <select name="to[]" id="js_multiselect_to_1" class="form-control" size="8" multiple="multiple"></select>
                                </div>
                              </div>`;
      
      this.querySelector("#audio-modal-select").innerHTML = audioModalSelect;

      $('.js-multiselect').multiselect({
        right: '#js_multiselect_to_1',
        rightAll: '#js_right_All_1',
        rightSelected: '#js_right_Selected_1',
        leftSelected: '#js_left_Selected_1',
        leftAll: '#js_left_All_1'
      });
    }
        
    

    this.querySelector("#audio-modal-save").addEventListener("click", function (e) {
      e.preventDefault();
      this.saveAudioFile();
    }.bind(this));
    
    this.querySelector("#audio-modal-cancel").addEventListener("click", function(e) {
      e.preventDefault();
      this.clearForm();
      this.querySelector(".close").click()
    }.bind(this));
    
    this.querySelector(".close").addEventListener("click", function () {
      this.clearForm();
    }.bind(this));
    
    //Shows file name of audio file to be uploaded
    $("#manageAudioModal").on('change', '.btn-file :file', function() {
      var input = $(this),
      numFiles = input.get(0).files ? input.get(0).files.length : 1,
      label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.trigger('fileselect', [numFiles, label]);
    });
    
    $("#manageAudioModal").on('fileselect', '.btn-file :file', function(event, numFiles, label) {
      
      var input = $(this).parents('.input-group').find(':text'),
      log = numFiles > 1 ? numFiles + ' files selected' : label;
      
      if( input.length ) {
        input.val(log);
      } else {
        if( log ) alert(log);
      }     
    });
  }

  clearForm() {
    this.querySelector("#manageAudioModal .errors").innerHTML = "";
    this.querySelector("#audio-upload-description").value = null;
    this.querySelector("#audio-upload-type-id").value = null;
    this.querySelector("#audio-upload-file").value = null;
    this.querySelector("#audio-upload-file-text").value = null;
    this.querySelectorAll(".error").forEach((elem) => {
      elem.classList.remove("error");
    });
    if(this.querySelector("#js_multiselect_to_1")) {
      this.querySelector("#js_multiselect_to_1").options.forEach(element => {
        element.selected = false;
      });
      this.querySelector(".js-multiselect").options.forEach(element => {
        element.selected = false;
      });
      this.querySelectorAll(".btn-block")[3].click();
    }
  }

  async saveAudioFile() {
    this.querySelector("#manageAudioModal .errors").innerHTML = "";
    this.querySelectorAll(".error").forEach((elem) => {
      elem.classList.remove("error");
    });
    //Throws error is user hasn't entered a description or chosen a file
    if(this.querySelector("#audio-upload-file").files.length == 0 || this.querySelector("#audio-upload-description").value.length == 0 || this.querySelector("#audio-upload-type-id").value == 'null') {
      this.querySelector("#audio-upload-file").files.length == 0 ? this.querySelector("#audio-upload-file-text").classList.add("error") : null;
      this.querySelector("#audio-upload-description").value.length == 0 ? this.querySelector("#audio-upload-description").classList.add("error") : null;
      this.querySelector("#audio-upload-type-id").value == 'null' ? this.querySelector("#audio-upload-type-id").classList.add("error") : null;
      this.querySelector("#manageAudioModal .errors").innerHTML=`<div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>Warning!</strong> Please provide a description, type and audio file.
      </div>`;
      return;
    }
    //Throws an error if user hasn't selected an auto group
    if(this.querySelector("#js_multiselect_to_1")) {
      if(this.querySelector("#js_multiselect_to_1").length < 1) {
        this.querySelector("#js_multiselect_to_1").classList.add("error");
        this.querySelector("#manageAudioModal .errors").innerHTML=`<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Audio needs to be available to at least one group.
        </div>`;
        return;
      }
    }

    panel_refresh($('#manageAudioModal'));
    const formData = new FormData()
    formData.append('upload_file', '1');
    formData.append('audio_file', $("#audio-upload-file").prop('files')[0])
    formData.append('audio_description', $("#audio-upload-description").val())
    formData.append('target_audio_type_id', $("#audio-upload-type-id").val())
    if(this.group_id != null) {
      formData.append("group_id[]", this.group_id);
    } else {
      this.querySelector("#js_multiselect_to_1").options.forEach(element => {
        formData.append("group_id[]", element.value);
      });
    }
    let res = await fetch('/admin/target_audio', {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
      method: 'POST',
      body: formData
    });
    let json = await res.json();
    if(json.error != null) {
      this.querySelector("#manageAudioModal .errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>Warning!</strong> Unable to upload this audio file. Please try a different format.
      </div>`
      panel_refresh($('#manageAudioModal'));
    } else {
      this.savedCallback();
    // Fetches specific audio types for select statements.
    // data_binder = new DataBinder("");
    // await data_binder.fetchData();
    this.querySelector(".close").click() // Close modal?
    // this.clearForm() // Or clear form and leave open?
    panel_refresh($('#manageAudioModal'));
    }
  }
}

customElements.define("audio-upload-modal", AudioUploadModal)